var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompareCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H4C1.79086 0 0 1.79086 0 4V14C0 16.2091 1.79086 18 4 18H14C16.2091 18 18 16.2091 18 14V4C18 1.79086 16.2091 0 14 0Z",
    fill: "#F7C73E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9573 5.739C15.1872 5.51211 15.2114 5.15781 15.03 4.90409C15.0299 4.89703 15.0291 4.89224 15.0278 4.89047L15.0207 4.88188L15.0174 4.87835L15.0157 4.87659L15.0149 4.87579L15.0136 4.87447L14.9577 4.81901L14.9017 4.76364L14.9003 4.76234L14.8995 4.76155L14.8978 4.75987L14.8942 4.75665L14.8855 4.7496C14.8838 4.74841 14.879 4.74765 14.872 4.74763C14.6167 4.56874 14.2613 4.59264 14.0329 4.81933L14.0328 4.81938L6.99938 11.806L3.96673 8.81638C3.96668 8.81628 3.96662 8.81628 3.96657 8.81618C3.71121 8.56298 3.29724 8.56298 3.04195 8.81638C2.78605 9.07028 2.78586 9.48228 3.04209 9.73588L3.04231 9.73618L6.539 13.1829C6.53905 13.1829 6.53909 13.183 6.53914 13.183C6.79246 13.4336 7.21077 13.4336 7.46397 13.1829L7.46417 13.1827L14.9573 5.73903C14.9573 5.73902 14.9573 5.73901 14.9573 5.739ZM15.0129 4.87384V4.87381V4.87384Z",
    fill: "#151B26",
    stroke: "#151B26",
    strokeWidth: 0.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareCheckboxChecked);
export default ForwardRef;